const childRoutes = (prop) => [
  {
    path: 'application-list',
    name: prop + '.application_list',
    meta: { auth: true },
    component: () => import('../pages/application-list/List.vue')
  },
  {
    path: 'application-report',
    name: prop + '.application_report',
    meta: { auth: true },
    component: () => import('../pages/application-report/List.vue')
  },
  {
    path: 'resident-list',
    name: prop + '.resident_list',
    meta: { auth: true },
    component: () => import('../pages/resident-list/List.vue')
  },
  {
    path: 'resident-report',
    name: prop + '.resident_report',
    meta: { auth: true },
    component: () => import('../pages/resident-report/List.vue')
  },
  {
    path: 'instructor-attendance-report',
    name: prop + '.instructor_attendance_report',
    meta: { auth: true },
    component: () => import('../pages/instructor-attendance/List.vue')
  },
  {
    path: 'class-attendance-report',
    name: prop + '.class_attendance_report',
    meta: { auth: true },
    component: () => import('../pages/class-attendance/List.vue')
  },
  {
    path: 'follow-up-report',
    name: prop + '.follow_up_report',
    meta: { auth: true },
    component: () => import('../pages/follow-up-report/List.vue')
  },
  {
    path: 'evaluation-management-report',
    name: prop + '.evaluation_management_report',
    meta: { auth: true },
    component: () => import('../pages/evaluation-management-report/List.vue')
  },
  {
    path: 'resident-incident-report',
    name: prop + '.resident_incident_report ',
    meta: { auth: true },
    component: () => import('../pages/resident-incident-report/List.vue')
  },
  {
    path: 'case-file-report',
    name: prop + '.case_file_report',
    meta: { auth: true },
    component: () => import('../pages/case-file-report/List.vue')
  },
  {
    path: 'school-transfer-report',
    name: prop + '.school_transfer_report',
    meta: { auth: true },
    component: () => import('../pages/school-transfer-report/List.vue')
  },
  {
    path: 'monthly-resident-information-report',
    name: prop + '.monthly_resident_information_report',
    meta: { auth: true },
    component: () => import('../pages/monthly-resident-information-report/List.vue')
  },
  {
    path: 'assign-to-school-report',
    name: prop + '.assign_to_school_report',
    meta: { auth: true },
    component: () => import('../pages/assign-to-school-report/List.vue')
  },
  {
    path: 'legal-resident-summary-report',
    name: prop + '.legal_resident_summary_report',
    meta: { auth: true },
    component: () => import('../pages/resident-summary-report/List.vue')
  },
  {
    path: 'case-type-wise-legal-resident-report',
    name: prop + '.case_type_wise_legal_resident_report',
    meta: { auth: true },
    component: () => import('../pages/case-type-wise-legal-resident-report/List.vue')
  },
  {
    path: 'court-attendance-report',
    name: prop + '.court_attendance_report',
    meta: { auth: true },
    component: () => import('../pages/court-attendance-report/List.vue')
  }
]
const routes = [{
  path: '/child-service/reports',
  name: 'child_service.reports',
  component: () => import('@/layouts/ChildServiceLayout.vue'),
  meta: { auth: true },
  children: childRoutes('child_service.reports')
}]

export default routes
